module.exports = __webpack_public_path__ + "static/media/bts.ff0e0486.jpg";